export const LOAD_CMS_CANDIDATE_INFO_REQUEST = 'CMSCandidateInfo/LOAD_CMS_CANDIDATE_INFO_REQUEST';
export const LOAD_CMS_CANDIDATE_INFO_SUCCESS = 'CMSCandidateInfo/LOAD_CMS_CANDIDATE_INFO_SUCCESS';
export const LOAD_CMS_CANDIDATE_INFO_FAILURE = 'CMSCandidateInfo/LOAD_CMS_CANDIDATE_INFO_FAILURE';
export const ARCHIVE_SUBMISSION_REQUEST = 'CMSCandidateInfo/ARCHIVE_SUBMISSION_REQUEST';
export const ARCHIVE_SUBMISSION_SUCCESS = 'CMSCandidateInfo/ARCHIVE_SUBMISSION_SUCCESS';
export const ARCHIVE_SUBMISSION_FAILURE = 'CMSCandidateInfo/ARCHIVE_SUBMISSION_FAILURE';
export const RESET_UPDATED_IDS = 'CMSCandidateInfo/RESET_UPDATED_IDS';
